import React from 'react';
import { Alert } from 'shards-react';

interface InformationMessageProps {
  hasError: boolean;
  message: string | undefined;
  onDismiss: () => void;
}

const InformationMessage = ({ hasError, message, onDismiss }: InformationMessageProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  //   console.log();
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <div id="message" className="pb-1">
        <Alert theme={hasError ? 'danger' : 'success'} dismissible={onDismiss} open={message !== undefined && message.length > 0}>
          {message}
        </Alert>
      </div>
    </>
  );
};

export default InformationMessage;
